import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CarouselType } from '../../../common';
import { CarouselItemSelectEventInfo } from '../../interfaces/carousel-item-select-gtm.interface';
import { CarouselViewModel } from '../carousel/carousel.view-model';
import { TopCarouselViewModel } from './top-carousel.view-model';

@Component({
  selector: 'osn-shared-top-carousel',
  templateUrl: './top-carousel.component.html',
  styleUrls: ['./top-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopCarouselComponent {
  @Input() public showSeoTitle = false;
  @Output() public carouselItemSelect: EventEmitter<CarouselItemSelectEventInfo> = new EventEmitter();
  @Output() public carouselItemImpression = new EventEmitter<{ guid: string; index: number; carouselTitle: string }>();

  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private _vm: TopCarouselViewModel;
  public carouselViewModel: CarouselViewModel;
  public canNavigateOnTitleClick = false;

  constructor() {}

  @Input()
  public set vm(vm: TopCarouselViewModel) {
    this._vm = vm;
    this.carouselViewModel = {
      items: vm.items,
      layout: vm.layout,
      type: CarouselType.TopCarousel,
      resolved: vm.resolved,
    };
  }

  public get vm() {
    return this._vm;
  }

  public get routerLink(): string {
    return this.vm.routerLink;
  }

  public get visible(): boolean {
    return !!this.vm && (!this.vm.resolved || (this.vm.resolved && this.vm.items && this.vm.items.length > 0));
  }

  @HostBinding('class.carousel-container')
  public get carouselContainerClass() {
    return this.visible;
  }

  public onCarouselItemImpression(contentInfo: { guid: string; index: number }): void {
    this.carouselItemImpression.emit({ guid: contentInfo.guid, index: contentInfo.index, carouselTitle: this._vm.localizedTitles.en });
  }

  public onCarouselItemSelect({ carouselItemDetails, carouselTitle }): void {
    this.carouselItemSelect.emit({ guid: carouselItemDetails.id, carouselTitle, carouselItemType: carouselItemDetails.category });
  }
}
